import { render, staticRenderFns } from "./Methods.vue?vue&type=template&id=f6222cc4&scoped=true&"
import script from "./Methods.vue?vue&type=script&lang=js&"
export * from "./Methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6222cc4",
  null
  
)

export default component.exports